import { clearAll } from '../services/storage.js';
import { ConfirmDialog } from './confirm-dialog.js';
import './toast-container.js';

const SETTINGS_KEY = 'threatscope_settings';

const template = document.createElement('template');
template.innerHTML = `
  <div class="detail-panel">
    <div class="detail-panel-header">
      <h2>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px">
          <circle cx="12" cy="12" r="3"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
        </svg>
        Settings
      </h2>
      <button class="btn btn-icon" id="close-settings">&times;</button>
    </div>
    <div class="detail-panel-body">
      <div class="settings-section">
        <h3>Threat Intel API Keys</h3>
        <div class="settings-row">
          <label>AbuseIPDB API Key</label>
          <input type="password" id="setting-abuseipdb" placeholder="Enter AbuseIPDB API key">
        </div>
        <div class="settings-row">
          <label>AlienVault OTX API Key</label>
          <input type="password" id="setting-alienvault" placeholder="Enter AlienVault OTX API key">
        </div>
        <div class="settings-row">
          <label>GreyNoise API Key (optional)</label>
          <input type="password" id="setting-greynoise" placeholder="Enter GreyNoise API key">
        </div>
        <div class="settings-row">
          <label>Shodan API Key</label>
          <input type="password" id="setting-shodan" placeholder="Enter Shodan API key">
        </div>
      </div>

      <div class="settings-section">
        <h3>Cloudflare Worker</h3>
        <div class="settings-row">
          <label>Traceroute Worker URL</label>
          <input type="url" id="setting-worker-url" placeholder="https://threatscope-worker.your-account.workers.dev">
        </div>
      </div>

      <div class="settings-section">
        <h3>Data Management</h3>
        <div class="settings-row" style="justify-content:flex-start;gap:8px;flex-wrap:wrap">
          <span style="color:var(--text-muted);font-size:0.8rem">Data stored locally in browser (IndexedDB).</span>
        </div>
        <div class="settings-row">
          <button class="btn btn-danger" id="clear-all-data">Clear All Data</button>
        </div>
      </div>

      <div style="margin-top: 16px;">
        <button class="btn btn-primary" id="save-settings" style="width:100%">Save Settings</button>
      </div>
      <div id="settings-status"></div>
    </div>
  </div>
`;

export class SettingsPanel extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = template.innerHTML;
  }

  connectedCallback() {
    this.loadSettings();

    this.querySelector('#close-settings').addEventListener('click', () => {
      const overlay = this.closest('.detail-overlay');
      if (overlay) overlay.remove();
    });

    this.querySelector('#save-settings').addEventListener('click', () => this.saveSettings());
    this.querySelector('#clear-all-data').addEventListener('click', async () => {
      const confirmed = await ConfirmDialog.show({
        title: 'Clear All Data',
        message: 'This will permanently delete all logs, threats, enrichments, and import history. This action cannot be undone.',
        confirmText: 'Delete Everything',
        variant: 'danger',
      });
      if (!confirmed) return;
      await clearAll();
      document.dispatchEvent(new CustomEvent('threatscope:data-cleared'));
      document.dispatchEvent(new CustomEvent('threatscope:stats-update'));
      window.showToast('All data cleared', 'success');
    });
  }

  loadSettings() {
    try {
      const settings = JSON.parse(localStorage.getItem(SETTINGS_KEY)) || {};
      this.querySelector('#setting-abuseipdb').value = settings.abuseipdbKey || '';
      this.querySelector('#setting-alienvault').value = settings.alienvaultKey || '';
      this.querySelector('#setting-greynoise').value = settings.greynoiseKey || '';
      this.querySelector('#setting-shodan').value = settings.shodanKey || '';
      this.querySelector('#setting-worker-url').value = settings.workerUrl || '';
    } catch (err) {
      console.warn('[settings] failed to load settings:', err.message);
    }
  }

  saveSettings() {
    try {
      const settings = {
        abuseipdbKey: this.querySelector('#setting-abuseipdb').value.trim(),
        alienvaultKey: this.querySelector('#setting-alienvault').value.trim(),
        greynoiseKey: this.querySelector('#setting-greynoise').value.trim(),
        shodanKey: this.querySelector('#setting-shodan').value.trim(),
        workerUrl: this.querySelector('#setting-worker-url').value.trim(),
      };
      localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
      window.showToast('Settings saved', 'success');
    } catch (err) {
      console.warn('[settings] failed to save settings:', err.message);
      window.showToast('Failed to save settings (storage quota?)', 'error');
    }
  }
}

customElements.define('settings-panel', SettingsPanel);
